"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "signing-key/5.0.2";
